import React, { useEffect, useState } from 'react'
import './datatable.css'
import {
  useTable,
  usePagination,
  useSortBy,
  useRowSelect,
  useFilters, useGlobalFilter
} from "react-table";
import { Checkbox } from "./checkbox";
import { GlobalFilter } from "./globalfilter";
import asc from '../../images/ascSort.png';
import desc from '../../images/descSort.png';
import defaultSort from '../../images/defaultSort.png';

const Table =
  ({
    columns,
    data,
    globalsearch,
    allcolumnsearch,
    emptyMessage,
    pagination,
    check,
    size,
    gotopage,
    records,
    placeholder,
    rows,
    numberrows,
    tableClassName,
    tableClassNameCheck,
    tableClass,
    parentCallback,
    btnLabel,
    setCheckedRows,
    checkedRows,
    selectall,
  }) => {
    const [checked, setChecked] = useState(false);
    const sorting=true;
    const handleClick = (index) => {
      console.log(index, "index");
      if (index === "all") {
        var arrayObj = []
        var arrayObj1 = []
        if (checkedRows) {
          if (Object.keys(checked).length !== Object.keys(checkedRows).length) {
            for (var i = 0; i < data.length; i++) {
              var indx = "checked" + i;
              arrayObj1[i] = { [indx]: false }
            }
          }
          else {
            for (var i = 0; i < data.length; i++) {
              var indx = "checked" + i;
              arrayObj[i] = { [indx]: true }
            }
          }
          if (Object.keys(checked).length === Object.keys(checkedRows).length)
            setChecked(arrayObj1);
          else
            setChecked(arrayObj);
        }
      }
      else {
        var ind = "checked" + index;
        if (Object.values(checked)[index]) {
          setChecked({ ...checked, [ind]: !Object.values(checked)[index] })
        } else {
          setChecked({ ...checked, [ind]: true });
        }
      }
    }

    const defaultColumn = React.useMemo(
      () => ({
        Filter: DefaultColumnFilter
      }), []
    );

    function DefaultColumnFilter({
      column: { filterValue, setFilter }
    }) {
      return (
        <div>
          <input
            className="search-bar"
            value={filterValue}
            onChange={(e) => {
              setFilter(e.target.value);
            }}
            placeholder="Search Column..."
          />
        </div>
      );
    }


    const filterTypes = React.useMemo(
      () => ({
        text: (rows, id, filterValue) => {
          return rows.filter((row) => {
            const rowValue = row.values[id];
            return rowValue !== undefined
              ? String(rowValue)
                .toLowerCase()
                .startsWith(String(filterValue).toLowerCase())
              : true;
          });
        }
      }), []
    );
    const handleCheckbox = (event, row) => {
      var array = [...checkedRows];
      if (event.target.checked === true) {
        if (row !== "all") {
          let index = array.indexOf(+row.index);
          if (index === -1)  array.push(row.index);  
        } else {
          array = data.map((item,index) => index);
        }
      }
      else {
        if (row !== "all") {
          array = array.filter((item) => { return +item !== +row.index })
        } else {
          array = [];
        }
      }
      setCheckedRows(array);
    };


    const {
      getTableProps,
      getTableBodyProps,
      headerGroups,
      footerGroups,
      prepareRow,
      page,
      canPreviousPage,
      canNextPage,
      pageCount,
      gotoPage,
      nextPage,
      previousPage,
      state,
      state: { pageIndex, pageSize },
      setPageSize,
      setGlobalFilter,
      selectedFlatRows
    } = useTable(
      {
        columns,
        data,
        defaultColumn,
        filterTypes,
        autoResetPage: false,
        initialState: { pageSize: size }
      },
      useGlobalFilter,
      useFilters,
      useSortBy,
      usePagination,
      useRowSelect,
      check ?
        (hooks) => {
          hooks.visibleColumns.push((columns) => {
            return [
              {
                id: 'selection',
                Header: ({ getToggleAllPageRowsSelectedProps }) =>
                  check ? (
                    <>
                    <input
                      type="checkbox"
                      onChange={(e) => handleCheckbox(e, "all")}
                      defaultChecked={
                        checkedRows.length === data.length
                      }
                      id="selectAll"
                    />
                    {selectall?
                    <label htmlFor="selectAll" className="ml-2">Select All</label>:""}
                    </>
                  ) : (
                    // <Checkbox {...getToggleAllPageRowsSelectedProps()} />
                    ""
                  ),
                width: 10,
                Cell: ({ row }) =>
                  check ? (
                    <input
                      type="checkbox"
                      onChange={(e) => {
                        handleCheckbox(e, row);
                      }}
                      defaultChecked={
                        checkedRows.indexOf(row.index)!==-1
                      }
                    />
                  ) : (
                    // <Checkbox {...row.getToggleRowSelectedProps()} />
                    ""
                  ),
              },
              ...columns
            ]
          })
        } : ""

    );


    var selectedList = selectedFlatRows.map((row => row.original))
    // function callfunc() {
    //   parentCallback(selectedList);
    // }
    var selectedNumber = selectedList && selectedList.length
    useEffect(()=>{
      setPageSize(size)
    },[size])

    const { globalFilter } = state

    return (
      <>
        {globalsearch ?
          <div className="row pb-3 align-items-center">
            <div className="offset-md-8 col-md-4">
              <GlobalFilter
                filter={globalFilter}
                setFilter={setGlobalFilter}
                placeholder={placeholder}
              />
              {/* <i className="fas fa-search icon-search"/> */}
            </div>
            {rows ? <div className="col-md text-right mr-2">Total No-: {numberrows}</div> : ""}
          </div>
          : ""
        } 

        <div className={`${tableClass ? "" : "datatable-box"}`}>
          <div className={`${tableClass ? "" : "inner-box2 inner-box table-design"}`}>

            <table {...getTableProps()} className={`table ${tableClass ? "" : "datatable"} ${check ? tableClassNameCheck : tableClassName}`}>

              <thead>
                {headerGroups.map((group) => (
                  <>
                    <tr {...group.getHeaderGroupProps()}>
                      {group.headers.map((column) => (
                        <th {...column.getHeaderProps(sorting ? column.getSortByToggleProps() : "")}>
                          {sorting ?
                            <span style={{flexDirection:"row",display:"flex"}}><div style={{maxWidth:"2px"}}>{column.isSorted ? (column.isSortedDesc ?  <img src={asc} style={{height:"12px", width:"9px",marginRight:"2px"}} alt="backImage"/> :  <img src={desc} style={{height:"12px", width:"9px",marginRight:"2px"}} alt="backImage"/>) :  <img src={defaultSort} style={{height:"13px",marginRight:"2px"}} alt="backImage"/>}</div> <div className='col'>{column.render("Header")}</div></span>
                            : ""}
                        </th>
                      ))}
                    </tr>
                    {allcolumnsearch ?
                      <tr {...group.getHeaderGroupProps()}>
                        {group.headers.map((column) => (
                          column.isSearchable ?
                            <td {...column.getHeaderProps()}>
                              <div>{column.canFilter ? column.render("Filter") : null}</div>
                            </td>
                            : <td></td>
                        ))}
                      </tr> : ""
                    }
                  </>
                ))}
              </thead>

              <tbody {...getTableBodyProps()}>
                {
                  page?.length==0?(
                    <tr>
                      {" "}
                      <td className="notavailable" colspan="12">
                        {emptyMessage}
                      </td>{" "}
                    </tr>
                  ):(
                    page?.map((row, i) => {
                      prepareRow(row);
                      return (
                        <tr {...row.getRowProps()}>
                          {row.cells.map((cell) => {
                            return (
                              <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                            );
                          })}
                        </tr>
                      );
                    })
                  )
                }
               
              </tbody>

            </table>

          </div>
        </div>
        {/* {check ?
          <button className="control-btn mt-4 float-left" id="checksubmit" onClick={callfunc}>
            {btnLabel ? btnLabel : "Selected (" + selectedNumber + ")"}
          </button>
          : ""} */}

        <div className="pagination-outer mt-4">
          <div className="pagination-inner row">

            {gotopage ?
              <div className="row col-12 col-xl-2 align-items-center justify-content-end m-1">
                <span className="row mr-2">Go to page:</span>
                <input type="number"
                  min={1}
                  max={Math.ceil(numberrows/pageSize)}
                  className="col-3 search-bar"
                  defaultValue={pageIndex + 1}
                  onChange={(e) => {
                    const page = e.target.value ? Number(e.target.value) - 1 : 0;
                    gotoPage(page);
                  }}
                  onInput={(e) => {e.target.value = !!e.target.value && Math.abs(e.target.value) >= 1 && e.target.value <= Math.ceil(numberrows/pageSize) ? Math.abs(e.target.value) : null}}
                />
              </div>
              : ""}

            {records ?
              <div className="row align-items-center col-12 col-xl-2 justify-content-end m-1">
                <select
                  className=" search-bar search-bar2"
                  onChange={(e) => {
                    setPageSize(Number(e.target.value));
                  }}
                >
                  <option key={size} value={size}>Show {size} records</option>
                  {[10,20,30].map((pageSize) => (
                    <option key={pageSize} value={pageSize}>
                      Show {pageSize} records
                    </option>
                  ))}
                </select>
              </div>
              : ""}

            {pagination ?
              <div className="pagination col-xl-4 row align-items-center justify-content-end">
                <button onClick={() => gotoPage(0)} disabled={!canPreviousPage} className="control-btn mr-2"> {"<<"} </button>{" "}
                <button onClick={() => previousPage()} disabled={!canPreviousPage} className="control-btn"> {"<"} </button>{" "}
                <span className="m-2 control-btn2"><strong>{pageIndex + 1}</strong></span>
                <button onClick={() => nextPage()} disabled={!canNextPage} className="control-btn">  {">"} </button>{" "}
                <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage} className="control-btn ml-2 mr-3"> {">>"} </button>{" "}
                {/* <span>
              Page{" "}
              <strong>
                {pageIndex + 1} of {pageCount}
              </strong>
            </span> */}
              </div>
              : ""}
          </div>
        </div>

      </>
    );
  }

export default Table;
